import { combineReducers } from 'redux'

import { reducer as oidcReducer } from 'redux-oidc';
import userManagerReducer from "../Authorization/reducer";

import { brickReducer } from '../Pages/ProductBricks/ProductBrickReducer'
import { bricksReducer } from '../Pages/ProductBricks/ProductBricksReducer'

import { serReducer } from '../Pages/ProductSeries/ProductSerReducer'
import { seriesReducer } from '../Pages/ProductSeries/ProductSeriesReducer'

import { templateReducer } from '../Pages/Templates/TemplateReducer'
import { templatesReducer } from '../Pages/Templates/TemplatesReducer'

import { unprocessedRecordsReducer } from '../Pages/UnprocessedRecords/UnprocessedRecordsReducer'

import { reportingReducer } from '../Pages/Reporting/ReportingReducer'

import { advancedSearchReducer } from '../Pages/AdvancedSearch/AdvancedSearchReducer'
import { productReducer } from '../Pages/ProductView/ProductViewReducer'
import { webReducer } from '../Pages/ProductView/Panels/Web/WebReducer'


import { holidayReducer } from '../Pages/Holidays/HolidayReducer'
import { holidaysReducer } from '../Pages/Holidays/HolidaysReducer'

import { locationReducer } from '../Pages/Locations/LocationReducer'
import { locationsReducer } from '../Pages/Locations/LocationsReducer'
import { statesReducer } from '../Pages/Locations/StatesReducer'

import { locationMenuGroupReducer } from '../Pages/LocationMenuGroups/LocationMenuGroupReducer'
import { locationMenuGroupsReducer } from '../Pages/LocationMenuGroups/LocationMenuGroupsReducer'

import { bidReducer } from '../Pages/BidTracker/BidReducer'
import { bidsReducer } from '../Pages/BidTracker/BidsReducer'

import { userReducer } from '../Pages/Users/UserReducer'
import { usersReducer } from '../Pages/Users/UsersReducer'

import { quoteReducer } from '../Pages/Quotes/QuoteReducer'
import { quotesReducer } from '../Pages/Quotes/QuotesReducer'

import { surveyReducer } from '../Pages/Surveys/SurveyReducer'
import { surveysReducer } from '../Pages/Surveys/SurveysReducer'

import { rankingReportsReducer } from '../Pages/RankingReports/RankingReportsReducer'

import { inactiveReportReducer } from '../Pages/InactiveReport/InactiveReportReducer'

import { scopeReducer } from '../Pages/Scopes/ScopeReducer'
import { scopesReducer } from '../Pages/Scopes/ScopesReducer'

import { sowReducer } from '../Pages/Sows/SowReducer'
import { sowsReducer } from '../Pages/Sows/SowsReducer'

import { jobsReducer } from '../Pages/Jobs/JobsReducer'

import { locationsMngtReducer } from '../Pages/LocationMngt/LocationsReducer' 

import { bidsMngtReducer } from '../Pages/BidTrackerAdmin/BidTrackerReducer' 


export const bridgeProductManagementApp = combineReducers({
    oidc: oidcReducer,
    userManager: userManagerReducer,

    brick: brickReducer,
    bricks: bricksReducer,

    ser: serReducer,
    series: seriesReducer,

    template: templateReducer,
    templates: templatesReducer,

    unprocessed_records: unprocessedRecordsReducer,

    reporting: reportingReducer,

    advancedsearch: advancedSearchReducer,
    product: productReducer,
    overrides: webReducer,


    holiday: holidayReducer,
    holidays: holidaysReducer,

    location: locationReducer,
    locations: locationsReducer,
    states: statesReducer,

    locationMenuGroup: locationMenuGroupReducer,
    locationMenuGroups: locationMenuGroupsReducer,

    bid: bidReducer,
    bids: bidsReducer,

    user: userReducer,
    users: usersReducer,

    quote: quoteReducer,
    quotes: quotesReducer,

    survey: surveyReducer,
    surveys: surveysReducer,

    reports: rankingReportsReducer,

    inactivereport: inactiveReportReducer,

    scope: scopeReducer,
    scopes: scopesReducer,

    sow: sowReducer,
    sows: sowsReducer,

    jobs: jobsReducer,

    locationsMngt: locationsMngtReducer,

    bidsMngt: bidsMngtReducer
});
